var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBomb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#6e7589",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.313 123.313c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625 0l-32 32-9.375 9.375-20.688-20.688c-12.484-12.5-32.766-12.5-45.25 0l-16 16c-1.261 1.261-2.304 2.648-3.31 4.051C240.326 132.865 216.741 128 192 128 86.133 128 0 214.133 0 320s86.133 192 192 192 192-86.133 192-192c0-24.741-4.864-48.327-13.426-70.065 1.402-1.007 2.79-2.049 4.051-3.31l16-16c12.5-12.492 12.5-32.758 0-45.25l-20.688-20.688 9.375-9.375 32.001-31.999zM192 224c-52.938 0-96 43.063-96 96 0 8.836-7.164 16-16 16s-16-7.164-16-16c0-70.578 57.422-128 128-128 8.836 0 16 7.164 16 16s-7.164 16-16 16zM459.02 148.98c-6.25-6.25-16.375-6.25-22.625 0s-6.25 16.375 0 22.625l16 16a15.95 15.95 0 0 0 11.313 4.688 15.95 15.95 0 0 0 11.313-4.688c6.25-6.25 6.25-16.375 0-22.625l-16.001-16zM340.395 75.605a15.95 15.95 0 0 0 11.313 4.688 15.95 15.95 0 0 0 11.313-4.688c6.25-6.25 6.25-16.375 0-22.625l-16-16c-6.25-6.25-16.375-6.25-22.625 0s-6.25 16.375 0 22.625l15.999 16zM400 64c8.844 0 16-7.164 16-16V16c0-8.836-7.156-16-16-16-8.844 0-16 7.164-16 16v32c0 8.836 7.156 16 16 16zM496 96.586h-32c-8.844 0-16 7.164-16 16s7.156 16 16 16h32c8.844 0 16-7.164 16-16s-7.156-16-16-16zM436.98 75.605a15.95 15.95 0 0 0 11.313 4.688 15.95 15.95 0 0 0 11.313-4.688l32-32c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625 0l-32 32c-6.251 6.25-6.251 16.375-.001 22.625z",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomb);
export default __webpack_public_path__ + "static/media/bomb.5626a46186ce9be1c045b859774a3159.svg";
export { ForwardRef as ReactComponent };